/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _TreatmentBaseEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable ember/no-runloop, parog-web/migrate-non-patch-forms */
import { action } from "@ember/object";
import { next } from "@ember/runloop";
import { service } from "@ember/service";
import { HTMLDropdownElement } from "core";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import MedicationTherapeuticalGroup from "core/models/medication-therapeutical-group";
import Dosage from "core/models/prescriptions/dosage";
import Medication from "core/models/prescriptions/medication";
import MedicationRequest from "core/models/prescriptions/medication-request";
import Timing from "core/models/prescriptions/timing";
import TreatmentPrescriptionChangedJournalEvent from "core/models/treatment-prescription-changed-journal-event";
import AnalyticsService from "core/services/analytics";
import validateArray from "core/validators/validate-array";
import { validatePresence } from "ember-changeset-validations/validators";
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import DS from "ember-data";
import IntlService from "ember-intl/services/intl";
import $ from "jquery";
import { sortBy } from "core/utils/sort";
import styles from "./index.module.css";
let TreatmentBaseEditionFormComponent = (_class = (_TreatmentBaseEditionFormComponent = class TreatmentBaseEditionFormComponent extends JournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "analytics", _descriptor2, this);
    _defineProperty(this, "journalEventProperties", ["occurredAt", "prescriptions", "recommendedTherapeuticalClasses", "notRecommendedTherapeuticalClasses"]);
    _defineProperty(this, "retrieveJournalEvent", () => {
      return this.patient.lastTreatmentPrescriptionChangedJournalEvent;
    });
    _defineProperty(this, "timings", [new Timing({
      frequency: 1,
      period: 1,
      periodUnit: "d",
      when: ["MORN"]
    }), new Timing({
      frequency: 1,
      period: 1,
      periodUnit: "d",
      when: ["EVE"]
    }), new Timing({
      frequency: 1,
      period: 1,
      periodUnit: "d",
      when: ["CD"]
    }), new Timing({
      frequency: 2,
      period: 1,
      periodUnit: "d"
    }), new Timing({
      frequency: 2,
      period: 1,
      periodUnit: "d",
      when: ["CD", "MORN"]
    }), new Timing({
      frequency: 2,
      period: 1,
      periodUnit: "d",
      when: ["CD", "EVE"]
    }), new Timing({
      frequency: 3,
      period: 1,
      periodUnit: "d"
    }), new Timing({
      frequency: 4,
      period: 1,
      periodUnit: "d"
    }), new Timing({
      frequency: 3,
      period: 1,
      periodUnit: "wk"
    }), new Timing({
      frequency: 1,
      period: 1,
      periodUnit: "wk"
    }), new Timing({
      frequency: 1,
      period: 1,
      periodUnit: "d"
    }), new Timing({
      frequency: 1,
      period: 1,
      periodUnit: "mo"
    }), new Timing({
      frequency: 1,
      period: 2,
      periodUnit: "mo"
    }), new Timing({
      frequency: 1,
      period: 4,
      periodUnit: "mo"
    }), new Timing({
      frequency: 0,
      period: 0,
      periodUnit: undefined
    })]);
    _defineProperty(this, "doseQuantities", ["0.25", "0.5", "1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10"]);
  }
  get medications() {
    return this.store.peekAll("medication-specialty");
  }
  get validations() {
    const validations = this.journalEventClass.validations(this.intl);
    validations["prescriptions"] = validateArray({
      medication: validatePresence({
        presence: true,
        description: "Le médicament"
      })
    });
    return validations;
  }
  retrieveModel() {
    const model = super.retrieveModel();
    this.therapeuticalClassItems = this.store.peekAll("medication-therapeutical-group");
    model.recommendedTherapeuticalClasses = model.recommendedTherapeuticalClasses?.map(group => group.name) || [];
    model.notRecommendedTherapeuticalClasses = model.notRecommendedTherapeuticalClasses?.map(group => group.name) || [];
    if (this.isNewMode) model.occurredAt = new Date();

    // If this is the first TreatmentPrescriptionChangedJournalEvent of the patient, we must
    // initialize the model's  prescriptions to an empty array
    model.prescriptions ??= [];
    model.prescriptions = model.prescriptions.map(prescription => {
      // If the PS chose the medication from the list then the Medication has a cisCode.
      // Otherwise, if he enters an other medication himself, then the medication has only a name.
      const medication = prescription.medication.cisCode ? prescription.medication.cisCode : prescription.medication.name;
      let doseQuantity, timing;
      if (prescription.dosage) {
        doseQuantity = prescription.dosage.doseQuantity;
        timing = prescription.dosage.timing ? prescription.dosage.timing.computedId : null;
      }
      return {
        medication,
        doseQuantity,
        timing,
        comment: prescription.comment
      };
    });
    return model;
  }
  computePayload() {
    const payload = super.computePayload();
    payload.prescriptions = payload.prescriptions.map(prescription => {
      // Here we don't know if the medication is a cisCode or a custom name added by the PS
      // So we have to check if the cisCode exists in our Medications references.
      const isKnownCisCode = this.medications.find(medication => {
        return medication.cisCode === prescription.medication;
      });
      const medication = new Medication(isKnownCisCode ? isKnownCisCode : {
        name: prescription.medication
      });

      // Create the corresponding dosage if the medic enters values.
      const doseQuantity = prescription.doseQuantity ? prescription.doseQuantity : null;
      const timing = prescription.timing ? Timing.fromComputedId(prescription.timing) : null;
      const dosage = doseQuantity != null || timing != null ? new Dosage({
        doseQuantity,
        timing
      }) : undefined;
      return new MedicationRequest({
        medication,
        dosage,
        comment: prescription.comment
      });
    });
    payload.recommendedTherapeuticalClasses = payload.recommendedTherapeuticalClasses.map(group => this.therapeuticalClassItems.find(e => e.name == group));
    payload.notRecommendedTherapeuticalClasses = payload.notRecommendedTherapeuticalClasses.map(group => this.therapeuticalClassItems.find(e => e.name == group));
    return payload;
  }
  async saveModel() {
    const journalEventRecord = await super.saveModel();
    this.analytics.trackJeCreation(journalEventRecord);
    return journalEventRecord;
  }
  get prescriptions() {
    return this.changeset.get("prescriptions");
  }
  onCommentFocusIn() {
    // This is a workaround for what seems to be an ember-changeset bug.
    // For some reason, the first time the input value changed,
    // the changeset enters a strange state where it ignores
    // the new values typed into the input field…
    this.setAsDirty();
  }
  indexOfChangeset(prescriptionChangeset) {
    return this.prescriptions.indexOf(prescriptionChangeset.data);
  }
  onPrescriptionChangesetUpdate(prescriptionChangeset) {
    // If the prescription is not really dirty, no need to set as dirty.
    if (prescriptionChangeset.isPristine) return;
    prescriptionChangeset.execute();
    this.setAsDirty();
  }
  onPrescriptionChangesetUpdateAndClearTotalDose(prescriptionChangeset) {
    // If the prescription is not really dirty, no need to set as dirty.
    if (prescriptionChangeset.isPristine) return;

    // HACK: watch out! This selector will only work in production because
    // we do not strip the data-test selectors
    // To avoid this workaround, we would probably need to update our
    // Form.Dropdown component to use ...attributes
    const selector = '.ui.dropdown[data-test-dropdown="doseQuantity"]';
    const dropdownElement = $($(selector)[this.indexOfChangeset(prescriptionChangeset)]);
    next(this, function () {
      // The DOM has been updated with the new item values in the dropdown,
      // but the dropdown FUI module has not been informed of it and as a consequence,
      // does not display the correct text.
      // Let's tell the dropdown FUI module to update its text UI by programmatically
      // selecting the value this was already selected.
      dropdownElement.dropdown("set selected", dropdownElement.dropdown("get value"));
    });
    this.onPrescriptionChangesetUpdate(prescriptionChangeset);
  }
  get suggestionComments() {
    return ["Pendant les repas.", "Espacer les prises de 12 heures.", "À prendre à  6h et à 18h.", "À prendre à  7h et à 19h.", "À prendre à  8h et à 20h.", "À prendre à  9h et à 21h.", "À prendre à 10h et à 22h."];
  }
  appendComment(prescriptionChangeset, str) {
    const prevComment = prescriptionChangeset.get("comment") || "";
    prescriptionChangeset.set("comment", `${prevComment} ${str}`);
    this.onPrescriptionChangesetUpdate(prescriptionChangeset);
  }
  get meds() {
    const meds = {};
    this.medications.forEach(medication => {
      const dose = medication.dose;
      const unit = medication.unit;
      if (dose && unit) {
        meds[medication.cisCode] = {
          dose,
          unit
        };
      }
    });
    return meds;
  }
  get medicationsGroupedByAtc() {
    // Group medication by ATC code
    return this.medications.slice().sort(sortBy("medicationMolecule.isGroupLeader", "desc")).reduce((acc, medication) => {
      const atc = medication.medicationMolecule.atc;
      // If the molecule is not already in the accumulator, add it
      if (!acc.has(atc)) {
        // Set the accumulator value with the current medication
        acc.set(atc, [{
          key: medication.cisCode,
          value: medication.longDescription
        }]);
      }

      // IF the molecule already exists in the accumulator, push the current medication in its value
      acc.get(atc)?.push({
        key: medication.cisCode,
        value: medication.longDescription
      });
      return acc;
    }, new Map());
  }
  setAsDirty() {
    // Actually the changeset is not dirty when :
    // - we add an element to an array (here a prescription)
    // - we remove an element from an array
    // - we modify a subchangeset
    // So the idea here is to modify the prescriptions reference
    // each time there is a modification to dirty the changeset.
    // Another way to do this should be to override the isDirty of the viewModel.
    this.changeset.set("prescriptions", [].concat(this.prescriptions));
  }
}, _defineProperty(_TreatmentBaseEditionFormComponent, "forcDisplayName", "Traitement"), _defineProperty(_TreatmentBaseEditionFormComponent, "fullComponentId", "treatment/base-edition-form"), _defineProperty(_TreatmentBaseEditionFormComponent, "journalEventClass", TreatmentPrescriptionChangedJournalEvent), _TreatmentBaseEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "analytics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onCommentFocusIn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCommentFocusIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPrescriptionChangesetUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPrescriptionChangesetUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPrescriptionChangesetUpdateAndClearTotalDose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPrescriptionChangesetUpdateAndClearTotalDose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appendComment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "appendComment"), _class.prototype), _class);
export { TreatmentBaseEditionFormComponent as default };